import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TimePickerContext = /*#__PURE__*/createContext(undefined);
export const TimePickerProvider = ({
  selectStylesOverrides = {},
  children
}) => {
  return /*#__PURE__*/_jsx(TimePickerContext.Provider, {
    value: {
      selectStylesOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `TimePicker` component.
 * Note: The context is only available when the `TimePicker` component is rendered as an ancestor.
 * @returns TimePickerContext - The context for the `TimePicker` component.
 * @returns TimePickerContext.fieldsetStylesOverrides - Style overrides to be applied to the `Fieldset` component.
 * @returns TimePickerContext.selectStylesOverrides - Style overrides to be applied to the `Select` component.
 */
export const useTimePickerContext = () => {
  const timePickerContext = useContext(TimePickerContext);
  return timePickerContext;
};